import React, { Component } from 'react'
import { Menu, Input, Icon, DatePicker, Pagination, Affix, Row, Modal, Checkbox } from "antd"
import ReportCard from "app/components/normal/ecs/ReportCard"
import queryString from 'query-string'
import { observer, Provider, inject } from "mobx-react"
import moment from "moment"
import reportIcon from "app/styles/images/sp/report-selected.svg"
import Store from "app/stores/ecs/report"
import ReportDetail from "app/components/normal/ecs/ReportDetail"
import { Route } from 'react-router-dom'
import "./Index.scss"

const RangePicker = DatePicker.RangePicker
const { Search } = Input

@inject('entrance') @observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      currentPageIndex: 1,
      isHistory: "查看历史数据",
      dateValue: null,
      tableData: [],
      totalCount: 0,
      showCreateNewGroup: false,
      showBatchExportGroup: false,
      reportGroupData: {},
      searchType: 'keywords',
      app: "0",              //头部筛选选中的状态 计算
      belong: "all",         //头部筛选选中的状态 自己 分享
      dayKey: "-1"           //头部筛选选中的状态 日期
    }
  }

  componentWillReceiveProps(nextProps) {
    const { searchType } = this.state
    const { location } = this.props
    const { location: nextLocation } = nextProps
    if (nextLocation.search && queryString.parse(nextLocation.search).holdData) {
      return
    }

    if (nextLocation.search !== location.search) {
      const searchObj = queryString.parse(nextLocation.search)
      this.setState({
        inputSearch: searchObj[`${searchType}`]
      })
      if (nextLocation.search) {
        this.loadLimitedData(searchObj)
      } else {
        this.loadAllData()
      }
    }
  }

  componentDidMount() {
    const { list } = this.store
    const { location } = this.props

    list.getApps('common', { filter: 'used' });
    (() => {
      if (location.search) {
        const searchObj = queryString.parse(location.search)
        this.setState({
          inputSearch: searchObj.keywords
        })
        return this.loadLimitedData(searchObj)
      } else {
        return this.loadAllData()
      }
    })().then(() => {
      const pathArr = location.pathname.split('/')
      const reportId = pathArr.slice(-1)[0]
      if (pathArr.slice(-2)[0] === 'detail') {
        this.initDetailData(reportId)
      }
    })
  }

  loadLimitedData(queryObj) {
    return this.store.list.filterData(queryObj, 'notInitPage')
  }

  loadAllData() {
    const { list } = this.store
    return list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
        }
      )
  }

  onDataChange = (e, type) => {
    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap } } = this.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  onBelongChange = (e) => {
    this.setState({
      belong: e.key,
    })
    let { list: { filterData } } = this.store

    filterData({ belong: e.key })
  }

  disabledDate = (current) => {
    return current && current.valueOf() > Date.now()
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.store

    this.setState({
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  onShowSizeChange = (current, pageSize) => {
    const { list: { filterData } } = this.store

    filterData({ limit: pageSize })
  }

  onPaginChange = selectedPageNumber => {
    let {
      list
    } = this.store

    list.changePagin(selectedPageNumber)
    document.getElementById("contentTop").scrollIntoView(true)
  }
  /**
 * 只会在刷新页面的时候调用
 **/
  initDetailData = (reportId) => {
    const { getDetailData, list: { tableData } } = this.store

    let reportGroupData = tableData.find(
      data => {
        let index = data.reportList.findIndex(report => report.reportId === reportId)
        if (index > -1) {
          this.setState({
            dataIndex: index
          })
        }
        return index > -1
      }
    )

    this.setState({ reportGroupData })

    getDetailData(reportId)
  }

  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords,
    })
  }

  searchData = () => {
    const { match, history } = this.props
    history.push({
      pathname: `${match.url}/search`,
      search: queryString.stringify({
        keywords: this.state.inputSearch,
        app: this.state.appQueryValue
      })
    })
  }

  toggleUnread = (e) => {
    const {
      list
    } = this.store

    list.filterData({ unread: e.target.checked })
  }

  dataSwitch = (index, record) => {
    let { getDetailData, clearDetailData } = this.store

    clearDetailData()

    this.setState({
      dataIndex: index,
    })

    getDetailData(record.reportId)
      .then(res => {
        record.isRead = true
      })
  }

  openReportDetail = (data, record) => {
    let { getDetailData, clearDetailData } = this.store
    let { history, match } = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    clearDetailData()

    this.setState({
      dataIndex: index,
      reportGroupData: data
    })

    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(res => {
        record.isRead = true
      })
    history.push({
      pathname: `${match.url}/detail/${reportId}`,
      search: queryString.stringify({ // 此处不可以使用 beautifyObj，不传 keywords 会导致本次查询复用上次的 keywords(此处可拓展其他字段)
        holdData: true
      })
    })
  }

  render() {
    const { list: { tableData, totalCount, currentPageIndex, queryMap }, detailData } = this.store
    const { match, history, entrance } = this.props
    const { reportGroupData, dataIndex } = this.state
    let tmp = this.store.detailData
    let templates = entrance.templates
    return (
      <Provider store={this.store}>
        <div className="ecs report-page">
          <h2 className="page-title"><img alt="" src={reportIcon} />报告列表</h2>
          {this.renderHeader()}
          <div className="report-card-wrap">
            {tableData.map((data, index) =>
              <ReportCard
                key={data.groupId + "_groupId"}
                data={data}
                onOpenDetail={this.openReportDetail}
                gorupIndex={index}
                store={this.store}
              />
            )}
          </div>
          <div className="pagin-bottom">
            <Pagination
              showSizeChanger
              pageSize={queryMap.limit}
              onShowSizeChange={this.onShowSizeChange}
              onChange={this.onPaginChange}
              defaultCurrent={1}
              current={currentPageIndex}
              total={totalCount} />
          </div>
          {/* 报告详情modal */}
          <Route
            path={`${match.url}/detail/:id`}
            render={() => {
              return (
                <Modal
                  title="报告详情"
                  width={1172}
                  footer={0}
                  maskClosable={false}
                  visible={true}
                  onCancel={history.goBack}
                  className="detail-modal"
                >
                  <ReportDetail
                    data={reportGroupData}
                    index={dataIndex}
                    detailData={detailData}
                    reportList={reportGroupData.reportList}
                    templates={templates}
                    dataSwitch={this.dataSwitch}
                    store={this.store}
                    groupId={reportGroupData.groupId}
                  />
                </Modal>
              )
            }}
          />
        </div>
      </Provider>
    )
  }
  renderHeader = () => {
    const { inputSearch } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}>
        <div className="affix-back">
          <div className="first-line">
            {this.renderUserMenu()}
            {this.renderDayMenu()}
          </div>
          <Row type="flex" justify="space-between" align="middle">
            <div className="report-search-bar">
              <Row type="flex" justify="space-between" align="middle" className="content">
                <Row type="flex" align="middle">
                  <div className="search-input">
                    <Search
                      value={inputSearch}
                      placeholder="输入样本名/所在批次号搜索"
                      size="default"
                      onChange={this.changeSearch.bind(this)}
                      onSearch={this.searchData}
                    />
                  </div>
                  <div className="unread-btn">
                    <Checkbox onChange={this.toggleUnread} >只看未读</Checkbox>
                  </div>
                </Row>
              </Row>
            </div>
          </Row>
        </div>
      </Affix>
    )
  }
  renderUserMenu = () => {
    return (
      <div className="user-menu">
        <Menu
          className="menu-all" onClick={e => this.onDataChange(e, "belong")}
          key="menu_share_0"
          selectedKeys={[this.state.belong]}
          mode="horizontal">
          <Menu.Item key="all">
            <Icon type="cloud-o" />全部
          </Menu.Item>
          <Menu.Item key="self">
            <Icon type="team" />自己的
          </Menu.Item>
          <Menu.Item key="share">
            <Icon type="share-alt" />分享而来
          </Menu.Item>
        </Menu>
      </div>
    )
  }
  renderDayMenu = () => {
    return (
      <div className="report-search-time-bar">
        <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
          selectedKeys={[this.state.dayKey]}
          mode="horizontal"
          key="menu_date_0">
          <Menu.Item key="-1">
            <Icon type="calendar" />全部
          </Menu.Item>
          <Menu.Item key="0">今天</Menu.Item>
          <Menu.Item key="3">三天内</Menu.Item>
          <Menu.Item key="7">七天内</Menu.Item>
          <Menu.Item key="15">十五天内</Menu.Item>
          <Menu.Item key="30">三十天内</Menu.Item>
        </Menu>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.dateValue}
          onChange={this.dateChange}
          onOk={this.onDataChange}
          disabledDate={this.disabledDate}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/ecs/report/index.js